// Local saved report -> visual markers. No network requests or source-site lookups.
export const STATUS = {
  X: { label: 'Replaced', color: '#c74036' },
  W: { label: 'Panel repair / welding', color: '#366daf' },
  C: { label: 'Corrosion', color: '#aa6417' },
  A: { label: 'Scratch', color: '#5a6e82' },
  U: { label: 'Dent / uneven surface', color: '#717242' },
  T: { label: 'Damage', color: '#886057' },
  '?': { label: 'Unmapped status', color: '#545b66' },
};

// Outlined Arial Bold glyphs: each ink bounding box is centered at (50,50)
// and 52 units high in a 100x100 viewBox. No SVG text or runtime font dependency.
export const BADGE_GLYPHS = {
  X: 'M25.827 76 43.598 48.865 27.494 24H39.767L50.195 40.707L60.411 24H72.577L56.402 49.255L74.173 76H61.51L49.982 58.016L38.419 76Z',
  W: 'M28.292 76 15.877 24H26.625L34.464 59.719L43.97 24H56.456L65.572 60.322L73.553 24H84.123L71.495 76H60.357L50 37.124L39.678 76Z',
  C: 'M62.057 56.654 71.901 59.776Q69.637 68.008 64.372 72.004Q59.107 76 51.012 76Q40.996 76 34.547 69.157Q28.099 62.314 28.099 50.446Q28.099 37.892 34.582 30.946Q41.065 24 51.629 24Q60.856 24 66.619 29.454Q70.049 32.678 71.764 38.715L61.714 41.116Q60.822 37.206 57.992 34.942Q55.162 32.678 51.115 32.678Q45.524 32.678 42.042 36.691Q38.561 40.704 38.561 49.691Q38.561 59.227 41.991 63.274Q45.421 67.322 50.909 67.322Q54.956 67.322 57.872 64.749Q60.788 62.177 62.057 56.654Z',
  A: 'M76.089 76H64.667L60.127 64.188H39.341L35.049 76H23.911L44.165 24H55.267ZM56.757 55.427 49.592 36.131 42.569 55.427Z',
  U: 'M29.615 24H39.938V51.691Q39.938 58.283 40.322 60.236Q40.985 63.375 43.478 65.276Q45.972 67.176 50.296 67.176Q54.691 67.176 56.923 65.38Q59.155 63.584 59.608 60.968Q60.062 58.353 60.062 52.284V24H70.385V50.854Q70.385 60.062 69.548 63.863Q68.711 67.665 66.461 70.28Q64.212 72.896 60.445 74.448Q56.679 76 50.61 76Q43.286 76 39.502 74.309Q35.718 72.617 33.521 69.914Q31.324 67.211 30.626 64.247Q29.615 59.852 29.615 51.273Z',
  T: 'M44.768 76V32.797H29.338V24H70.662V32.797H55.267V76Z',
  '?': 'M54.178 62.728H45.225Q45.19 60.797 45.19 60.375Q45.19 56.022 46.629 53.213Q48.069 50.404 52.388 46.893Q56.706 43.381 57.549 42.293Q58.848 40.573 58.848 38.501Q58.848 35.622 56.548 33.568Q54.248 31.514 50.351 31.514Q46.594 31.514 44.066 33.656Q41.538 35.797 40.59 40.186L31.531 39.063Q31.918 32.778 36.886 28.389Q41.854 24 49.93 24Q58.427 24 63.448 28.442Q68.469 32.883 68.469 38.782Q68.469 42.047 66.625 44.962Q64.782 47.876 58.743 52.897Q55.618 55.495 54.863 57.075Q54.108 58.655 54.178 62.728ZM45.225 76V66.134H55.091V76Z',
};

// v2.9: coordinates match the user's unaltered 2000x2000 PNGs, encoded as WebP.
// Side silhouettes in the structure drawing locate pillars, not exterior repairs.
export const DRAWING_SIZES = { exterior: [2000, 2000], structure: [2000, 2000] };
// Anchors use each drawing's coordinate system, independent of screen size.
// Schematic part regions, never measured damage locations.
// Official source positions and audit: docs/PART_MAPPING_AUDIT.md.
const PART_ROWS = [
  ['ext-hood', '후드', 'Hood', 'exterior', 'RANK_ONE', [1000,545]],
  ['ext-front-fender-l', '프론트 휀더(좌)', 'Front fender (L)', 'exterior', 'RANK_ONE', [230,500]],
  ['ext-front-fender-r', '프론트 휀더(우)', 'Front fender (R)', 'exterior', 'RANK_ONE', [1770,500]],
  ['ext-front-door-l', '프론트 도어(좌)', 'Front door (L)', 'exterior', 'RANK_ONE', [235,895]],
  ['ext-front-door-r', '프론트 도어(우)', 'Front door (R)', 'exterior', 'RANK_ONE', [1765,895]],
  ['ext-rear-door-l', '리어 도어(좌)', 'Rear door (L)', 'exterior', 'RANK_ONE', [245,1175]],
  ['ext-rear-door-r', '리어 도어(우)', 'Rear door (R)', 'exterior', 'RANK_ONE', [1755,1175]],
  ['ext-trunk-lid', '트렁크 리드', 'Trunk lid', 'exterior', 'RANK_ONE', [1000,1550]],
  ['ext-radiator-support', '라디에이터 서포트(볼트체결부품)', 'Radiator support (bolted)', 'exterior', 'RANK_ONE', [1000,365]],
  ['ext-roof', '루프 패널', 'Roof panel', 'exterior', 'RANK_TWO', [1000,1125]],
  ['ext-quarter-l', '쿼터 패널(좌)', 'Quarter panel (L)', 'exterior', 'RANK_TWO', [255,1515]],
  ['ext-quarter-r', '쿼터 패널(우)', 'Quarter panel (R)', 'exterior', 'RANK_TWO', [1745,1515]],
  ['ext-sill-l', '사이드실 패널(좌)', 'Side sill (L)', 'exterior', 'RANK_TWO', [120,1015]],
  ['ext-sill-r', '사이드실 패널(우)', 'Side sill (R)', 'exterior', 'RANK_TWO', [1880,1015]],
  ['frame-front-panel', '프론트 패널', 'Front panel', 'structure', 'RANK_A', [1000,455]],
  ['frame-rear-panel', '리어 패널', 'Rear panel', 'structure', 'RANK_A', [1000,1615]],
  ['frame-inside-panel-l', '인사이드 패널(좌)', 'Inside panel (L)', 'structure', 'RANK_A', [795,610]],
  ['frame-inside-panel-r', '인사이드 패널(우)', 'Inside panel (R)', 'structure', 'RANK_A', [1205,610]],
  ['frame-cross-member', '크로스 멤버', 'Cross member', 'structure', 'RANK_A', [1000,810]],
  ['frame-trunk-floor', '트렁크 플로어', 'Trunk floor', 'structure', 'RANK_A', [1000,1430]],
  ['frame-front-side-member-l', '프론트 사이드 멤버(좌)', 'Front side member (L)', 'structure', 'RANK_B', [920,665]],
  ['frame-front-side-member-r', '프론트 사이드 멤버(우)', 'Front side member (R)', 'structure', 'RANK_B', [1080,665]],
  ['frame-rear-side-member-l', '리어 사이드 멤버(좌)', 'Rear side member (L)', 'structure', 'RANK_B', [805,1440]],
  ['frame-rear-side-member-r', '리어 사이드 멤버(우)', 'Rear side member (R)', 'structure', 'RANK_B', [1195,1440]],
  ['frame-front-wheelhouse-l', '프론트 휠하우스(좌)', 'Front wheelhouse (L)', 'structure', 'RANK_B', [795,750]],
  ['frame-front-wheelhouse-r', '프론트 휠하우스(우)', 'Front wheelhouse (R)', 'structure', 'RANK_B', [1205,750]],
  ['frame-rear-wheelhouse-l', '리어 휠하우스(좌)', 'Rear wheelhouse (L)', 'structure', 'RANK_B', [805,1285]],
  ['frame-rear-wheelhouse-r', '리어 휠하우스(우)', 'Rear wheelhouse (R)', 'structure', 'RANK_B', [1195,1285]],
  ['frame-front-pillar-l', '필러 패널(앞)(좌)', 'Front pillar (L)', 'structure', 'RANK_B', [450,880]],
  ['frame-front-pillar-r', '필러 패널(앞)(우)', 'Front pillar (R)', 'structure', 'RANK_B', [1550,880]],
  ['frame-middle-pillar-l', '필러 패널(중간)(좌)', 'Middle pillar (L)', 'structure', 'RANK_B', [445,1055]],
  ['frame-middle-pillar-r', '필러 패널(중간)(우)', 'Middle pillar (R)', 'structure', 'RANK_B', [1555,1055]],
  ['frame-floor', '플로어 패널', 'Floor panel', 'structure', 'RANK_C', [1000,1080]],
  ['frame-rear-pillar-l', '필러 패널(뒤)(좌)', 'Rear pillar (L)', 'structure', 'RANK_B', [430,1320]],
  ['frame-rear-pillar-r', '필러 패널(뒤)(우)', 'Rear pillar (R)', 'structure', 'RANK_B', [1570,1320]],
  ['frame-dash', '대쉬 패널', 'Dash panel', 'structure', 'RANK_C', [1000,910]],
  ['frame-package-tray', '패키지 트레이', 'Package tray', 'structure', 'RANK_C', [1000,1260]],
];
export const PARTS = PART_ROWS.map(([id, source, label, group, rank, anchor]) => ({ id, source, label, group, rank, anchor }));
const normalize = value => String(value || '').normalize('NFKC').replace(/\s+/g, '').replace(/펜더/g, '휀더');
const partIndex = new Map(PARTS.map(part => [normalize(part.source), part]));
for (const side of ['좌', '우']) {
  partIndex.set(normalize(`쿼터 패널(리어펜더)(${side})`), partIndex.get(normalize(`쿼터 패널(${side})`)));
  for (const [letter, position] of [['A','앞'],['B','중간'],['C','뒤']]) {
    partIndex.set(normalize(`필러 패널 ${letter}(${side})`), partIndex.get(normalize(`필러 패널(${position})(${side})`)));
  }
}
partIndex.set(normalize('라디에이터 서포트'), partIndex.get(normalize('라디에이터 서포트(볼트체결부품)')));
partIndex.set(normalize('프론트 대쉬 패널'), partIndex.get(normalize('대쉬 패널')));
const statusIndex = new Map([
  ['교환(교체)','X'], ['교환','X'], ['교체','X'], ['판금/용접','W'], ['판금(용접)','W'], ['판금','W'], ['용접','W'],
  ['부식','C'], ['흠집','A'], ['요철','U'], ['손상','T'],
].map(([label, code]) => [normalize(label), code]));
const rankGroup = rank => ['RANK_ONE','RANK_TWO'].includes(rank) ? 'exterior' : ['RANK_A','RANK_B','RANK_C'].includes(rank) ? 'structure' : 'other';
const rankLabel = rank => ({RANK_ONE:'Panel rank 1',RANK_TWO:'Panel rank 2',RANK_A:'Frame rank A',RANK_B:'Frame rank B',RANK_C:'Frame rank C'})[rank] || rank || 'Rank not provided';

export function parseReport(input = {}) {
  const countText = String(input.count ?? '').trim();
  const count = /^\d+$/.test(countText) && Number.isSafeInteger(Number(countText)) ? Number(countText) : null;
  const raw = input.issues;
  let rows = [], malformed = false;
  try {
    rows = typeof raw === 'string' ? (raw.trim() ? JSON.parse(raw) : []) : (raw ?? []);
    if (!Array.isArray(rows)) { rows = []; malformed = true; }
  } catch { malformed = true; }
  if (!countText && !rows.length && !malformed && (raw == null || raw === '')) {
    return { state: 'unavailable', items: [], warnings: [], count: null, date: input.date || '' };
  }
  const warnings = [];
  if (malformed) warnings.push('The saved panel data could not be read. No all-clear assessment is shown.');
  if (count === null) warnings.push('The source item count is missing or invalid.');
  if (count !== null && count !== rows.length) warnings.push('The saved item count and detailed records do not match.');
  const items = new Map();
  rows.forEach((row, index) => {
    if (!row || typeof row !== 'object' || typeof row.panel !== 'string' || !row.panel.trim() || typeof row.status !== 'string' || !row.status.trim() || (row.rank != null && typeof row.rank !== 'string')) {
      warnings.push(`Source record ${index+1} is incomplete and requires review.`);
      return;
    }
    const part = partIndex.get(normalize(row.panel));
    const rank = String(row.rank || '').trim();
    const group = rankGroup(rank);
    const rankMatches = !!part && part.rank === rank;
    const key = part && rankMatches ? part.id : `unmapped-${index}`;
    const statuses = row.status.split(/[,，、]/).map(value => value.trim()).filter(Boolean).map(value => {
      const code = statusIndex.get(normalize(value)) || (STATUS[value] ? value : '?');
      return { code, label: code === '?' ? value : STATUS[code].label, raw: value };
    });
    if (statuses.some(status => status.code === '?')) warnings.push('An unrecognized source status is preserved in the list.');
    if (part && !rankMatches) warnings.push('A part rank differs from the mapping. Its location is not inferred.');
    const item = items.get(key) || {
      id: key, source: row.panel, label: part?.label || row.panel, group,
      rank, rankLabel: rankLabel(rank), anchor: rankMatches ? part.anchor : null,
      mappingReason: !part ? 'Part not recognized' : !rankMatches ? 'Source rank needs review' : !part.anchor ? 'Schematic position not verified' : '',
      statuses: [],
    };
    for (const status of statuses) if (!item.statuses.some(old => old.code === status.code && old.label === status.label)) item.statuses.push(status);
    items.set(key, item);
  });
  const list = [...items.values()];
  return {
    state: warnings.length ? 'review' : (list.length ? 'marked' : 'unmarked'),
    items: list, warnings: [...new Set(warnings)], count, date: input.date || '',
  };
}

const HTMLElementBase = globalThis.HTMLElement || class {};
export class MaxInspectionDiagram extends HTMLElementBase {
  connectedCallback() {
    if (!this._mounted) {
      this._mounted = true;
      this.render();
    }
    this.syncProductHeadings();
    this.connectCarousel();
    this.placeBeforeInsurance();
  }
  disconnectedCallback() {
    this._events?.abort();
    this._resizeObserver?.disconnect();
    this._placementObserver?.disconnect();
    cancelAnimationFrame(this._scrollFrame);
    cancelAnimationFrame(this._cardFrame);
  }
  syncProductHeadings() {
    // Only the four existing main-product accordions; never replace their buttons,
    // icons, badges, aria-controls, content, or the theme's click handlers.
    const scope = this.closest('[id^="ProductPage-"]');
    if (!scope) return;
    const labels = {
      Specifications: ['specifications', 'Specifications'],
      OptionInfo: ['features', 'Features'],
      InsuranceHistory: ['accident history', 'Accident history'],
      ConditionReport: ['condition report', 'Condition report'],
    };
    for (const [prefix, [english, label]] of Object.entries(labels)) {
      for (const card of scope.querySelectorAll(`[id^="${prefix}-"]`)) {
        // A nested product/quick-view keeps its own scope.
        if (card.closest('[id^="ProductPage-"]') !== scope) continue;
        const title = card.querySelector(':scope > .ih-toggle > .ih-toggle-title');
        if (!title) continue;
        card.dataset.maxVehicleHeading = '';
        // Leave translated/custom/nested labels intact, including their markup.
        const text = title.textContent.trim();
        if (!title.children.length && text.toLowerCase() === english && text !== label) title.textContent = label;
      }
    }
  }
  render() {
    const report = parseReport({ issues: this.dataset.issues, count: this.dataset.count, date: this.dataset.date });
    this.report = report;
    this.innerHTML = `<details class="mid-shell" open>
      <summary class="mid-header"><div><p class="mid-eyebrow">VEHICLE CONDITION</p><h2>Body &amp; structure</h2><p class="mid-subtitle">Repair and damage items recorded in the supplied inspection report.</p></div><div class="mid-meta"><span class="mid-summary"></span><span class="mid-date"></span></div><svg class="mid-chevron" width="18" height="18" viewBox="0 0 24 24" aria-hidden="true"><path d="m6 9 6 6 6-6"/></svg></summary>
      <div class="mid-body">
      <div class="mid-notice" role="status"></div>
      <div class="mid-mapping-notice" role="status" hidden></div>
      <div class="mid-legend" aria-label="Inspection symbols"></div>
      <div class="mid-carousel">
        <div class="mid-controls">
          <div class="mid-views" role="group" aria-label="Choose inspection diagram"><button type="button" class="mid-view" data-slide="0" aria-pressed="true">Exterior panels <span class="mid-view-count" data-count-for="exterior"></span></button><button type="button" class="mid-view" data-slide="1" aria-pressed="false">Main structure <span class="mid-view-count" data-count-for="structure"></span></button></div>
          <div class="mid-arrows"><button type="button" class="mid-arrow mid-prev" aria-label="Previous diagram" disabled><svg width="18" height="18" viewBox="0 0 24 24" aria-hidden="true"><path d="m14 5-7 7 7 7"/></svg></button><span class="mid-page" aria-hidden="true">1 / 2</span><button type="button" class="mid-arrow mid-next" aria-label="Next diagram"><svg width="18" height="18" viewBox="0 0 24 24" aria-hidden="true"><path d="m10 5 7 7-7 7"/></svg></button></div>
        </div>
        <div class="mid-visuals" role="region" aria-roledescription="carousel" aria-label="Inspection diagrams; swipe or use arrow keys to change view" tabindex="0">
          <section class="mid-panel mid-exterior" role="group" aria-roledescription="slide" aria-label="Exterior panels, 1 of 2"><div class="mid-panel-title"><h3>Exterior panels</h3><span class="mid-panel-count"></span></div><p class="mid-orientation">FRONT ↑ <span>Vehicle L / R</span></p><div class="mid-stage"><div class="mid-drawing" data-group="exterior"><img alt="Generic exterior schematic, front at the top, vehicle left on the left" width="2000" height="2000" loading="lazy" draggable="false"></div></div><p class="mid-rear">REAR ↓</p><ul class="mid-list" aria-label="Exterior inspection items"></ul></section>
          <section class="mid-panel mid-structure" role="group" aria-roledescription="slide" aria-label="Main structure, 2 of 2"><div class="mid-panel-title"><h3>Main structure</h3><span class="mid-panel-count"></span></div><p class="mid-orientation">FRONT ↑ <span>Vehicle L / R</span></p><div class="mid-stage"><div class="mid-drawing" data-group="structure"><img alt="Generic structure schematic, front at the top; side views locate structural pillars, not exterior repairs" width="2000" height="2000" loading="lazy" draggable="false"></div></div><p class="mid-rear">REAR ↓</p><ul class="mid-list" aria-label="Structure inspection items"></ul></section>
        </div>
        <p class="mid-swipe-hint">Swipe to explore <span aria-hidden="true">↔</span></p>
      </div>
      <section class="mid-unmapped" hidden><h3>Other source items</h3><ul class="mid-list"></ul></section>
      <div class="mid-selection" aria-live="polite">Select a marked item to view its recorded condition.</div>
      <footer class="mid-footer"><p>Generic schematic, not a model-specific drawing. Symbols identify approximate part locations, not the size or exact position of damage. Unmapped parts remain listed.</p><p>No marked items does not mean accident-free. Read this alongside the full inspection and insurance records.</p></footer>
      </div>
    </details>`;
    const q = selector => this.querySelector(selector);
    q('.mid-summary').textContent = report.state === 'unavailable' ? 'Report unavailable' : report.state === 'review' ? 'Data needs review' : report.state === 'unmarked' ? 'No marked items in supplied data' : `${report.items.length} recorded ${report.items.length === 1 ? 'part' : 'parts'}`;
    q('.mid-summary').dataset.state = report.state;
    q('.mid-date').textContent = report.date ? `Inspection date · ${report.date}` : 'Inspection date not provided';
    const notice = q('.mid-notice');
    if (report.state === 'unavailable') notice.textContent = 'The source has not provided usable body/structure inspection data. No condition is inferred.';
    else if (report.warnings.length) notice.textContent = report.warnings.join(' ');
    else notice.hidden = true;
    const unplotted = report.items.filter(item => !item.anchor).length;
    if (unplotted) {
      q('.mid-mapping-notice').hidden = false;
      q('.mid-mapping-notice').textContent = `${unplotted} of ${report.items.length} recorded items cannot be plotted. See the item list for details; a blank area does not mean no damage.`;
    }
    q('.mid-carousel').hidden = report.state === 'unavailable' || (report.state === 'review' && !report.items.length);
    q('.mid-selection').hidden = !report.items.length;
    q('.mid-legend').hidden = report.state === 'unavailable';
    for (const [code, status] of Object.entries(STATUS)) {
      if (code === '?') continue;
      const label = document.createElement('span');
      label.title = `${code} · ${status.label}`;
      label.setAttribute('aria-label', `${code}: ${status.label}`);
      label.append(this.badge(code), document.createTextNode(({W:'Repair',U:'Dent'})[code] || status.label));
      q('.mid-legend').append(label);
    }
    for (const group of ['exterior', 'structure']) {
      const panel = q(`.mid-${group}`);
      const drawing = panel.querySelector('.mid-drawing');
      const img = drawing.querySelector('img');
      img.addEventListener('error', () => {
        drawing.hidden = true;
        const warning = document.createElement('p');
        warning.className = 'mid-image-error';
        warning.textContent = 'Diagram unavailable. See the recorded items below.';
        drawing.after(warning);
        panel.querySelector('.mid-panel-count').textContent = `${list.length} recorded · 0 shown`;
      }, { once: true });
      img.src = this.dataset[`${group}Image`] || '';
      const list = report.items.filter(item => item.group === group);
      q(`[data-count-for="${group}"]`).textContent = list.length;
      const shown = list.filter(item => item.anchor).length;
      panel.querySelector('.mid-panel-count').textContent = `${list.length} recorded · ${shown} shown`;
      if (!list.length) {
        const li = document.createElement('li'); li.className = 'mid-empty';
        if (report.state === 'marked' || report.state === 'unmarked') li.classList.add('mid-empty--unmarked');
        li.textContent = report.state === 'review' ? 'No readable items in this group. See the review notice.' : 'No items marked in supplied data.';
        panel.querySelector('.mid-list').append(li);
      }
      for (const item of list) {
        panel.querySelector('.mid-list').append(this.itemRow(item));
        if (!item.anchor) continue;
        const pin = document.createElement('button');
        pin.type = 'button'; pin.className = 'mid-pin'; pin.dataset.item = item.id;
        const [drawingWidth, drawingHeight] = DRAWING_SIZES[group];
        pin.style.left = `${item.anchor[0] / drawingWidth * 100}%`;
        pin.style.top = `${item.anchor[1] / drawingHeight * 100}%`;
        pin.setAttribute('aria-label', `${item.label}: ${item.statuses.map(s => s.label).join(', ')}`);
        pin.setAttribute('aria-pressed','false');
        pin.title = pin.getAttribute('aria-label');
        for (const status of item.statuses) pin.append(this.badge(status.code));
        pin.addEventListener('click', event => {
          // Close markers retain generous hit areas. Resolve pointer clicks by
          // proximity to the visible centers, not DOM stacking order.
          if (!event.detail) { this.select(item); return; }
          const nearest = [...drawing.querySelectorAll('.mid-pin')].map(button => {
            const rect = button.getBoundingClientRect();
            return {id:button.dataset.item, distance:Math.hypot(event.clientX-rect.x-rect.width/2,event.clientY-rect.y-rect.height/2)};
          }).sort((a,b) => a.distance-b.distance)[0];
          if (nearest && nearest.id !== item.id) {
            [...drawing.querySelectorAll('.mid-pin')].find(button=>button.dataset.item===nearest.id)?.focus({preventScroll:true});
          }
          this.select(list.find(candidate => candidate.id === nearest?.id) || item);
        });
        drawing.append(pin);
      }
    }
    const other = report.items.filter(item => item.group === 'other');
    q('.mid-unmapped').hidden = !other.length;
    other.forEach(item => q('.mid-unmapped .mid-list').append(this.itemRow(item)));
  }
  connectCarousel() {
    this._events?.abort();
    this._resizeObserver?.disconnect();
    cancelAnimationFrame(this._cardFrame);
    const controller = this._events = new AbortController();
    const options = { signal: controller.signal };
    const viewport = this.querySelector('.mid-visuals');
    const panels = [...viewport.querySelectorAll('.mid-panel')];
    // Match one adjacent card, not the opposite group's combined list height.
    // Observe real cards so theme styles, wrapped text and late fonts are included.
    const emptyPairs = panels.map((panel, index) => ({
      empty: panel.querySelector('.mid-empty--unmarked'),
      reference: panels[1-index]?.querySelector('.mid-list > li > .mid-item'),
    })).filter(pair => pair.empty && pair.reference);
    // Keep this breakpoint synchronized with the CSS: mobile carousel / desktop pair.
    const mobile = matchMedia('(max-width: 767px)');
    let pendingIndex = null;
    this._activeIndex = this._activeIndex || 0;
    const clearSelection = () => {
      this.querySelectorAll('[data-item]').forEach(element => element.setAttribute('aria-pressed','false'));
      this.querySelector('.mid-selection').textContent = 'Select a marked item to view its recorded condition.';
    };
    const active = index => {
      if (this._activeIndex !== index) clearSelection();
      this._activeIndex = index;
      this.querySelectorAll('.mid-view').forEach((button, i) => button.setAttribute('aria-pressed', String(i === index)));
      panels.forEach((panel, i) => {
        const hidden = mobile.matches && i !== index;
        if (hidden && panel.contains(document.activeElement)) viewport.focus({preventScroll:true});
        panel.inert = hidden;
        panel.setAttribute('aria-hidden', String(hidden));
      });
      this.querySelector('.mid-prev').disabled = !mobile.matches || index === 0;
      this.querySelector('.mid-next').disabled = !mobile.matches || index === panels.length - 1;
      this.querySelector('.mid-page').textContent = `${index+1} / ${panels.length}`;
      if (mobile.matches) viewport.style.height = `${Math.ceil(panels[index].getBoundingClientRect().height)}px`;
      else viewport.style.removeProperty('height');
    };
    const syncDiagramMetrics = () => {
      cancelAnimationFrame(this._cardFrame);
      // Write outside ResizeObserver delivery to avoid resize-loop warnings.
      this._cardFrame = requestAnimationFrame(() => {
        if (!this.isConnected || !this.querySelector('.mid-shell').open) return;
        for (const drawing of this.querySelectorAll('.mid-drawing')) {
          if (drawing.hidden) continue;
          const points = [...drawing.querySelectorAll('.mid-pin')].map(pin => {
            const rect = pin.getBoundingClientRect();
            return {pin, x:rect.x+rect.width/2, y:rect.y+rect.height/2};
          });
          for (const point of points) {
            const distance = Math.min(...points.filter(other=>other!==point).map(other=>Math.hypot(other.x-point.x,other.y-point.y)));
            // Only crowded pins shrink (12–18px); the 44px hit area stays intact.
            point.pin.style.setProperty('--mid-pin-size', `${Math.max(12,Math.min(18,distance-2))}px`);
          }
        }
        for (const {empty, reference} of emptyPairs) {
          const height = reference.getBoundingClientRect().height;
          if (!height) continue;
          const value = `${height}px`;
          if (empty.style.getPropertyValue('--mid-empty-card-height') !== value) {
            empty.style.setProperty('--mid-empty-card-height', value);
          }
        }
        active(this._activeIndex);
      });
    };
    this.goToSlide = (index, instant = false) => {
      if (!mobile.matches) {
        pendingIndex = null;
        viewport.scrollTo({left:0,behavior:'instant'});
        active(this._activeIndex);
        return;
      }
      const next = Math.max(0, Math.min(panels.length - 1, index));
      const reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
      pendingIndex = instant || reduced ? null : next;
      viewport.scrollTo({ left: viewport.clientWidth * next, behavior: instant || reduced ? 'instant' : 'smooth' });
      if (instant || reduced) active(next);
    };
    this.querySelectorAll('.mid-view').forEach(button => button.addEventListener('click', () => this.goToSlide(Number(button.dataset.slide)), options));
    this.querySelector('.mid-prev').addEventListener('click', () => this.goToSlide(this._activeIndex-1), options);
    this.querySelector('.mid-next').addEventListener('click', () => this.goToSlide(this._activeIndex+1), options);
    this.querySelector('.mid-shell').addEventListener('toggle', event => {
      // A delayed native toggle event must not cancel a newer keyboard/tab request.
      if (event.target.open) {
        this.goToSlide(pendingIndex ?? this._activeIndex, true);
        syncDiagramMetrics();
      }
    }, options);
    viewport.addEventListener('keydown', event => {
      if (!mobile.matches || event.target !== viewport || !['ArrowLeft','ArrowRight','Home','End'].includes(event.key)) return;
      event.preventDefault();
      this.goToSlide(event.key === 'Home' ? 0 : event.key === 'End' ? 1 : this._activeIndex + (event.key === 'ArrowRight' ? 1 : -1));
    }, options);
    viewport.addEventListener('scroll', () => {
      if (!mobile.matches) return;
      cancelAnimationFrame(this._scrollFrame);
      this._scrollFrame = requestAnimationFrame(() => {
        if (mobile.matches && viewport.clientWidth) {
          active(Math.max(0,Math.min(1,Math.round(viewport.scrollLeft / viewport.clientWidth))));
          if (pendingIndex !== null && Math.abs(viewport.scrollLeft-viewport.clientWidth*pendingIndex)<2) pendingIndex = null;
        }
      });
    }, { ...options, passive: true });
    // Native touch/trackpad scrolling, plus mouse dragging on non-interactive areas.
    let drag = null;
    viewport.addEventListener('pointerdown', event => {
      if (!mobile.matches || event.target.closest('button,a,input,select,textarea')) return;
      pendingIndex = null;
      if (event.pointerType !== 'mouse' || event.button !== 0) return;
      drag = { x:event.clientX, y:event.clientY, left:viewport.scrollLeft, id:event.pointerId, moving:false };
    }, options);
    viewport.addEventListener('pointermove', event => {
      if (!drag) return;
      const dx = event.clientX - drag.x;
      if (!drag.moving && Math.abs(dx) <= 6) return;
      if (!drag.moving && Math.abs(event.clientY-drag.y) > Math.abs(dx)) { drag = null; return; }
      if (!drag.moving) {
        drag.moving = true;
        viewport.setPointerCapture(event.pointerId);
        viewport.classList.add('mid-dragging');
      }
      event.preventDefault();
      viewport.scrollLeft = drag.left - dx;
    }, options);
    const endDrag = () => {
      if (!drag) return;
      const moved = drag.moving, id = drag.id;
      drag = null;
      if (viewport.hasPointerCapture(id)) viewport.releasePointerCapture(id);
      const nearest = Math.round(viewport.scrollLeft / (viewport.clientWidth || 1));
      viewport.classList.remove('mid-dragging');
      if (moved) this.goToSlide(nearest);
    };
    viewport.addEventListener('pointerup', endDrag, options);
    viewport.addEventListener('pointercancel', endDrag, options);
    viewport.addEventListener('pointerleave', () => { if (drag && !drag.moving) drag = null; }, options);
    viewport.addEventListener('wheel', () => {pendingIndex = null;}, {...options,passive:true});
    const layout = () => {
      cancelAnimationFrame(this._scrollFrame);
      if (drag && viewport.hasPointerCapture(drag.id)) viewport.releasePointerCapture(drag.id);
      drag = null; viewport.classList.remove('mid-dragging');
      this.dataset.layout = mobile.matches ? 'mobile' : 'desktop';
      if (mobile.matches) {
        viewport.setAttribute('tabindex','0');
        viewport.setAttribute('aria-roledescription','carousel');
        viewport.setAttribute('aria-label','Inspection diagrams; swipe or use arrow keys to change view');
      } else {
        viewport.removeAttribute('tabindex');
        viewport.removeAttribute('aria-roledescription');
        viewport.setAttribute('aria-label','Exterior and structure inspection diagrams');
        if (this.querySelector('.mid-controls').contains(document.activeElement)) this.querySelector('.mid-header').focus({preventScroll:true});
      }
      panels.forEach((panel,i) => {
        if (mobile.matches) panel.setAttribute('aria-roledescription','slide');
        else panel.removeAttribute('aria-roledescription');
        panel.setAttribute('aria-label', ['Exterior panels','Main structure'][i] + (mobile.matches ? `, ${i+1} of 2` : ''));
      });
      this.goToSlide(this._activeIndex, true);
      syncDiagramMetrics();
    };
    mobile.addEventListener('change', () => {clearSelection();layout();}, options);
    let width = viewport.clientWidth;
    this._resizeObserver = new ResizeObserver(() => {
      if (!viewport.clientWidth) return;
      if (width !== viewport.clientWidth) {
        width = viewport.clientWidth;
        this.goToSlide(pendingIndex ?? this._activeIndex, true);
      }
      active(this._activeIndex);
      syncDiagramMetrics();
    });
    this._resizeObserver.observe(viewport);
    panels.forEach(panel => this._resizeObserver.observe(panel));
    emptyPairs.forEach(({reference}) => this._resizeObserver.observe(reference));
    layout();
  }
  placeBeforeInsurance() {
    this._placementObserver?.disconnect();
    if (this.dataset.placement !== 'before-insurance') return;
    const scope = this.closest('[id^="ProductPage-"]') || this.closest('.shopify-section');
    const targetId = this.dataset.placementTarget;
    if (!scope) {
      this.dataset.placementStatus = 'scope-unavailable';
      delete this.dataset.placementAnchor;
      return;
    }
    // v2.10: some Signature/Reference products have no insurance/condition card.
    // Never borrow an anchor from recommendations or a nested product/quick-view.
    const candidates = prefix => [...scope.querySelectorAll('[id^="' + prefix + '-"]')].filter(element =>
      (element.closest('[id^="ProductPage-"]') || element.closest('.shopify-section')) === scope &&
      !this.contains(element) && !element.contains(this)
    );
    const unique = elements => elements.length === 1 ? elements[0] : null;
    const place = () => {
      // Duplicate render calls must not make two observers fight for one slot.
      const peers = [...scope.querySelectorAll('max-inspection-diagram[data-placement="before-insurance"]')]
        .filter(element => (element.closest('[id^="ProductPage-"]') || element.closest('.shopify-section')) === scope);
      if (peers.length > 1) {
        this.dataset.placementStatus = 'ambiguous-components';
        delete this.dataset.placementAnchor;
        return;
      }
      const insuranceCards = candidates('InsuranceHistory');
      // Honor the explicit ID first; a sole same-product card may use a product ID.
      const insurance = insuranceCards.find(element => element.id === targetId) || unique(insuranceCards);
      const condition = unique(candidates('ConditionReport'));
      const features = unique(candidates('OptionInfo'));
      const target = insurance || condition || features;
      if (!target) {
        this.dataset.placementStatus = 'target-unavailable';
        delete this.dataset.placementAnchor;
        return;
      }
      const after = !insurance && !condition;
      this.dataset.placementStatus = 'placed';
      this.dataset.placementAnchor = insurance ? 'insurance' : condition ? 'condition' : 'features';
      if (after) {
        if (target.nextElementSibling !== this) target.after(this);
      } else if (target.previousElementSibling !== this) target.before(this);
    };
    // Keep observing after a fallback: a delayed insurance card must take priority.
    // Ignore our own legend/selection/carousel text mutations. Idempotent placement
    // plus childList-only observation prevents status attributes from causing loops.
    this._placementObserver = new MutationObserver(records => {
      if (records.some(record => !this.contains(record.target))) place();
    });
    // Attach before moving, because moving this custom element reconnects it and
    // installs its next observer. Do not install another observer after place().
    this._placementObserver.observe(scope, { childList:true, subtree:true });
    place();
  }
  badge(code) {
    const symbol = Object.hasOwn(BADGE_GLYPHS, code) ? code : '?';
    const badge = document.createElement('span');
    badge.className = 'mid-badge'; badge.dataset.code = symbol;
    badge.style.setProperty('--mid-status', STATUS[symbol].color);
    badge.setAttribute('aria-hidden', 'true');
    const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    svg.setAttribute('class', 'mid-symbol');
    svg.setAttribute('viewBox', '0 0 100 100');
    svg.setAttribute('width', '100%'); svg.setAttribute('height', '100%');
    svg.setAttribute('focusable', 'false'); svg.setAttribute('aria-hidden', 'true');
    const path = document.createElementNS('http://www.w3.org/2000/svg', 'path');
    path.setAttribute('d', BADGE_GLYPHS[symbol]);
    svg.append(path); badge.append(svg);
    return badge;
  }
  itemRow(item) {
    const li = document.createElement('li');
    const button = document.createElement('button');
    button.type = 'button'; button.className = 'mid-item'; button.dataset.item = item.id;
    button.setAttribute('aria-pressed','false');
    const badges = document.createElement('span'); badges.className = 'mid-item-badges';
    item.statuses.forEach(status => badges.append(this.badge(status.code)));
    const body = document.createElement('span'); body.className = 'mid-item-body';
    const name = document.createElement('strong'); name.textContent = item.label;
    const status = document.createElement('span'); status.textContent = item.statuses.map(s => s.label).join(' · ');
    const note = document.createElement('small'); note.textContent = item.rankLabel + (item.anchor ? '' : ` · Not plotted: ${item.mappingReason}`);
    body.append(name, status, note); button.append(badges, body);
    button.addEventListener('click', () => this.select(item)); li.append(button); return li;
  }
  select(item) {
    this.querySelectorAll('[data-item]').forEach(element => element.setAttribute('aria-pressed', String(element.dataset.item === item.id)));
    this.querySelector('.mid-selection').textContent = `${item.label} — ${item.statuses.map(s => s.label).join(' · ')}. ${item.rankLabel}.${item.anchor ? '' : ' Location not mapped; source entry retained.'}`;
  }
}
if (globalThis.customElements && !customElements.get('max-inspection-diagram')) customElements.define('max-inspection-diagram', MaxInspectionDiagram);
